import "./style.css";
import { useTranslation } from "react-i18next";
import { ORANGE_TWO, WHITE } from "../../../theme";
import React, { useReducer, useState } from "react";
import { FormButton } from "../../../components/form";
import { useDispatch, useSelector } from "react-redux";
import { setAlert } from "../../../redux/reducers/alert";
import { deleteTransactions } from "../../../api/transactions";
import { SearchInput } from "../../../components/form/searchInput";
import { CSVLink } from "react-csv";

const exportHeaders = [
  { label: "Payee ID", key: "payeeId" },
  { label: "Name", key: "name" },
  { label: "Date", key: "date" },
  { label: "Amount", key: "amount" },
  { label: "Order ID", key: "orderId" },
];

export const TableHeader = ({
  selectedIds,
  deleteCallback,
  SearchValue,
  transactions = [],
  status = "APPROVED",
}) => {
  //* using useReducer Hook to pass the initialState and set searchvalues
  const [{ search, searchError }, setData] = useReducer(
    (state, newState) => ({ ...state, ...newState }),
    {
      search: "",
      searchError: false,
    }
  );

  const [loading, setLoading] = useState(false);
  //* use the  token for checking User
  const { token } = useSelector((state) => state.user);
  //*  for get and set the items in local Storage
  let local = JSON.parse(localStorage.getItem("notify"));
  local = local || [];
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const handleChange = (prop) => (event) => {
    SearchValue(event.target.value);
    setData({
      [prop]: event.target.value,
      searchError: false,
    });
  };
  // ! Message Alert
  const showErrorAlert = (message) => {
    dispatch(
      setAlert({
        severity: "error",
        message,
        show: true,
      })
    );
  };
  // ! Message Alert

  const showSuccessAlert = (message) => {
    dispatch(
      setAlert({
        severity: "success",
        message,
        show: true,
      })
    );
  };
  //* if multiple transactions Selected use This function also for delete the transactions
  const handleDelete = async () => {
    try {
      setLoading(true);
      const response = await deleteTransactions(selectedIds, token);
      if (response.status) {
        deleteCallback();
        showSuccessAlert(response?.message);
        //* Set data in localStorage to PushNotify
        local.push({
          message: "transaction deleted successfully",
          date: new Date().getTime(),
          newNotification: true,
        });
        localStorage.setItem("notify", JSON.stringify(local));
      } else {
        showErrorAlert(
          response?.message ||
            "Error in deleting Transactions. Please try again"
        );
      }

      setLoading(false);
    } catch (err) {
      setLoading(false);
      showErrorAlert(
        err.message || "Error in deleting school. Please try again"
      );
    }
  };
  const { role } = useSelector((state) => state.user);
  const exportData = transactions.map((transaction) => ({
    payeeId:
      transaction?.payeeType === "STUDENT"
        ? transaction?.studentRegNo
        : transaction?.parentRegNo,
    name: `${transaction?.firstName || ""} ${
      transaction?.lastName || ""
    }`.trim(),
    date: transaction?.gstPaidDate || "N/A",
    amount: transaction?.amount ?? "",
    orderId: transaction?.bankOrderID || "",
  }));

  return (
    <div className="table-header transactions-th">
      <div className="left-column">
        <SearchInput
          disabled={role === "readOnly" ? true : false}
          hideLabel={true}
          error={searchError}
          value={search}
          onChange={handleChange}
          label={t("text_search_by_order_or_payee")}
          name="search"
          height={40}
        />
      </div>

      <CSVLink
        className={`transactions-export-button ${
          exportData.length === 0 ? "transactions-export-button-disabled" : ""
        }`}
        data={exportData}
        headers={exportHeaders}
        filename={`${
          status.charAt(0).toUpperCase() + status.slice(1).toLowerCase()
        } transactions.csv`}
        onClick={() => exportData.length > 0}
        aria-disabled={exportData.length === 0}
      >
        {t("text_export")}
      </CSVLink>

      {/*<FormButton*/}
      {/*  height={40}*/}
      {/*  width={"10vw"}*/}
      {/*  borderTopRightRadius={15}*/}
      {/*  borderTopLeftRadius={15}*/}
      {/*  borderBottomLeftRadius={15}*/}
      {/*  borderBottomRightRadius={15}*/}
      {/*  borderColor={"rgb(253,184,155)"}*/}
      {/*  titleColor={WHITE}*/}
      {/*  hoverTitleColor={ORANGE_TWO}*/}
      {/*  hoverBorderColor={ORANGE_TWO}*/}
      {/*  backgroundColor={ORANGE_TWO}*/}
      {/*  hoverBackgroundColor={WHITE}*/}
      {/*  title={t("text_delete")}*/}
      {/*  disabled={true}*/}
      {/*  overRideButtonCheck={!selectedIds.length > 0}*/}
      {/*  onClickHandler={handleDelete}*/}
      {/*  loading={loading}*/}
      {/*  loadingColor={"rgb(253,184,155)"}*/}
      {/*  style={{*/}
      {/*    fontSize: "0.8vw",*/}
      {/*    fontWeight: "700",*/}
      {/*    textTransform: "capitalize",*/}
      {/*  }}*/}
      {/*/>*/}
    </div>
  );
};
